import React from 'react';
import styled from 'styled-components';
import { Icon } from '@common/ui/components';

type SelectProps = {
  name: string;
  options: string[] | number[];
  register: Function;
  placeholder: string;
  isRequired: boolean;
  validation?: object;
  defaultValue?: string | number;
};

export default function Select({
  name,
  options,
  register,
  validation,
  placeholder,
  isRequired,
  defaultValue
}: SelectProps) {
  return (
    <S_Box>
      <S_IconWrapper iconName="ic_ArrowDown" colorCode="grey500" size={16} />
      <S_Select defaultValue={defaultValue} required={isRequired} {...register(name, validation)}>
        <option hidden value="">
          {placeholder}
        </option>
        {options.map((value) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </S_Select>
    </S_Box>
  );
}

const S_Box = styled.div`
  position: relative;
  height: 48px;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.grey100};
  z-index: 0;
`;

const S_IconWrapper = styled(Icon)`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: -1;
`;

const S_Select = styled.select`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  padding-left: 16px;
  border: none;
  font-family: inherit;
  font-size: ${({ theme }) => theme.fontSizeForm2};
  color: ${({ theme }) => theme.grey900};
  background-color: transparent;
  appearance: none;

  :invalid {
    color: ${({ theme }) => theme.grey500};
  }
`;
